// angular
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

// addons
import { map, take } from 'rxjs/operators';

// store
import { Store, select } from '@ngrx/store';
import * as fromStore from '@store/index';

// models
import { IUser } from '@shared/models';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store<fromStore.State>
  ) {}

  canActivate() {
    return this.store.pipe(
      select(fromStore.UserSelectors.getInfo),
      take(1),
      map((user: IUser) => {
        if (user) { return true; }

        this.router.navigate(['/login']);

        return false;
      })
    );
  }
}
